"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payrollToPacketStatusMap = exports.packetToPayrollStatusMap = void 0;
const document_signer_1 = require("../../document_signer");
const payroll_hook_events_types_1 = require("./payroll.hook.events.types");
exports.packetToPayrollStatusMap = new Map([
    [document_signer_1.PacketStatusEnum.PENDING, payroll_hook_events_types_1.PayrollHookEventsStatus.PREPARING],
    [document_signer_1.PacketStatusEnum.PENDING_SIGNATURE, payroll_hook_events_types_1.PayrollHookEventsStatus.PENDING],
    [document_signer_1.PacketStatusEnum.SIGNED, payroll_hook_events_types_1.PayrollHookEventsStatus.FINISHED],
    [document_signer_1.PacketStatusEnum.CANCELED, payroll_hook_events_types_1.PayrollHookEventsStatus.CANCELED],
    [document_signer_1.PacketStatusEnum.FAILED, payroll_hook_events_types_1.PayrollHookEventsStatus.FAILED],
]);
exports.payrollToPacketStatusMap = new Map([...exports.packetToPayrollStatusMap].map(([key, value]) => [value, key]));
